import React from 'react';
import { Link } from 'react-router-dom';

import { Navbar } from '../components/Navbar';
import { PageMeta } from '../components/PageMeta';
import './NotFoundPage.css';

export const NotFoundPage: React.FC = () => (
  <div className="page-shell">
    <PageMeta
      title="404 — Page Not Found | 8080.AI"
      description="The page you're looking for doesn't exist. Head back to 8080.AI to continue building with AI agents."
      path="/404"
    />
    <Navbar />
    <div className="not-found-page">
      <div className="not-found-glow" aria-hidden />
      <span className="not-found-code">404</span>
      <h1 className="not-found-heading">Page not found</h1>
      <p className="not-found-sub">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <div className="not-found-links">
        <Link to="/" className="not-found-btn not-found-btn--primary">
          Back to Home
        </Link>
        <Link to="/pricing" className="not-found-btn not-found-btn--secondary">
          View Pricing
        </Link>
      </div>
      <div className="not-found-extra">
        <p>Here are some helpful links:</p>
        <ul>
          <li><Link to="/about">About 8080.AI</Link></li>
          <li><Link to="/pricing">Plans &amp; Pricing</Link></li>
          <li><Link to="/terms">Terms of Service</Link></li>
          <li><Link to="/privacy">Privacy Policy</Link></li>
        </ul>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
